<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<form class="xrx-drm" #f="ngForm">
  <div>
    <label [xdaTranslate]="'SDE_SECURITY'"></label>
    <button class="help nul-utility-btn" (click)="showHelp($event)">
      <i class="nul-button-glyph xgl-help"></i>
    </button>
  </div>
  <div class="cb mb-0 pb-0">
    <xrx-radio
      class="security-modes"
      [list]="securityModes"
      property="value"
      localize="display"
      [(checkedItem)]="drmConfig.securityMode"
      (checkedItemChange)="selectSecurityMode()">
    </xrx-radio>
  </div>

  <div class="h-divider"></div>

  <div class="form-group">
    <label [xdaTranslate]="'SDE_EXPIRATION_DATE'"></label>
    <div class="expiration-container">
      <div class="cb mb-6">
        <xrx-radio
          [list]="expireModes"
          property="value"
          localize="display"
          [(checkedItem)]="drmConfig.expireMode"
          (checkedItemChange)="selectExpireMode()">
        </xrx-radio>
      </div>
      @if (drmConfig.expireMode.value == 0) {
        <div>
          <xrx-calendar
            name="expiryDate"
            [(ngModel)]="expiryNgbDate"
            [minDate]="expiryMinNgbDate"
            [maxDate]="expiryMaxNgbDate"
            error="{{ errorExpiration }}"
            (change)="onExpireDateChange()"></xrx-calendar>
          <div
            class="info expireDateLabel"
            [xdaTranslate]="'SDE_EXPIRES_DATE'"></div>
        </div>
      }
      @if (drmConfig.expireMode.value == 1) {
        <div>
          <xrx-input
            class="expireDays inline"
            type="number"
            id="expireDays"
            name="expireDays"
            [(ngModel)]="drmConfig.expireDays"
            [required]="true"
            [minValue]="1"
            [maxValue]="maxExpireDays"
            [maxlength]="3"
            maxlengtherror="{{ maxDaysError }}"
            (change)="onExpireDaysChange($event)"
            classes="textField medium">
          </xrx-input>
          <div
            class="info expireDaysLabel"
            [xdaTranslate]="'SDE_EXPIRES_MANY_DAYS'"></div>
        </div>
      }
    </div>
  </div>

  <div class="h-divider"></div>

  <div class="form-group">
    <xrx-textarea
      name="note"
      [(ngModel)]="drmConfig.documentOptions.sideNote"
      [rows]="3"
      [maxlength]="128"
      (change)="onSettingChange($event)"
      [isMfd]="isMfd"
      label="SDE_INCLUDE_NOTE"
      placeholder="SDE_ENTER_YOUR_NOTE"></xrx-textarea>
  </div>

  @if (drmConfig.securityMode.display !== 'SDE_TRACK_VIEWS') {
    <div class="h-divider"></div>
  }

  @if (drmConfig.securityMode.display !== 'SDE_TRACK_VIEWS') {
    <div class="form-group maxreads-group">
      <label [xdaTranslate]="'SDE_MAXIMUM_VIEWS_PER'"></label>
      <div class="maxreads-container">
        <div class="cb mb-0">
          <xrx-radio
            display="inline"
            [list]="maxReadsModes"
            property="value"
            localize="display"
            [(checkedItem)]="drmConfig.maxReadsMode"
            (checkedItemChange)="selectMaxReadsMode()">
          </xrx-radio>
          <xrx-input
            class="maxreads inline"
            type="number"
            id="maxreads"
            name="maxreads"
            [(ngModel)]="drmConfig.maxReads"
            [required]="false"
            [minValue]="1"
            [maxValue]="maxReadsPerReader"
            [maxlength]="3"
            maxlengtherror="{{maxReadsError}}"
            (change)="onMaxReadsChange($event)"
            [disabled]="drmConfig.maxReadsMode.value === 0"
            classes="textField medium"
            error="{{ errorMaxReads }}">
          </xrx-input>
        </div>
      </div>
    </div>
  }

  <div class="h-divider mt-0"></div>

  <div class="form-group toggle-container">
    @if (drmConfig.securityMode.display !== 'SDE_TRACK_VIEWS') {
      <div>
        <xrx-toggle-switch
          [label]="'SDE_IDENTIFY_SCREEN_CAPTURE'"
          [isMfd]="isMfd"
          [switchOn]="drmConfig.documentOptions.steganography"
          (toggle)="onToggleSetting('steganography')">
        </xrx-toggle-switch>
      </div>
    }
    <div>
      <xrx-toggle-switch
        [label]="'SDE_INCLUDE_TIMESTAMP'"
        [isMfd]="isMfd"
        [switchOn]="drmConfig.documentOptions.timestamp"
        (toggle)="onToggleSetting('timestamp')">
      </xrx-toggle-switch>
    </div>
    <div>
      <xrx-toggle-switch
        [label]="'SDE_ALLOW_PRINTING'"
        [isMfd]="isMfd"
        [switchOn]="drmConfig.documentOptions.print"
        (toggle)="onToggleSetting('print')">
      </xrx-toggle-switch>
    </div>
  </div>

  <div class="h-divider"></div>

  <div class="mb-20">
    <xrx-input
      type="email"
      id="respondEmail"
      name="respondEmail"
      autocomplete="respondEmail"
      [(ngModel)]="respondEmail"
      [maxlength]="254"
      placeholder="SDE_ENTER_EMAIL_ADDRESS21"
      [required]="false"
      (change)="onRespondEmailChange($event)"
      label="SDE_RESPOND_TO"
      classes="textField medium"></xrx-input>
  </div>

  <!-- Domain Entry -->
  @if (drmConfig.securityMode.display === 'SDE_TRACK_VIEWERS') {
    <div class="form-group">
      <!-- hide if only one allowed domain: && !(isDomainsRestricted && allowedDomains.length == 1)-->
      <div class="h-divider"></div>
      @if (!isDomainsRestricted) {
        <xrx-toggle-switch
          [label]="'SDE_LIMIT_SPECIFIC_EMAIL'"
          [isMfd]="isMfd"
          [switchOn]="enableDomains"
          (toggle)="onToggleDomains()">
        </xrx-toggle-switch>
      } @else {
        <label [xdaTranslate]="'SDE_LIMIT_SPECIFIC_EMAIL'"></label>
      }
      @if (enableDomains) {
        <div class="address-container">
          @if (!isDomainsRestricted) {
            <div>
              <div
                class="info mb-2"
                [xdaTranslate]="'SDE_ENTER_UP_FMTSTR1'"
                [formatValues]="[maxDomains]"></div>
              <div class="d-flex">
                <xrx-input
                  type="text"
                  id="enterDomain"
                  name="enterDomain"
                  autocomplete="enterDomain"
                  [(ngModel)]="enterDomain"
                  placeholder="SDE_ENTER_DOMAIN_URL"
                  [required]="false"
                  (change)="onSettingChange($event)"
                  [isMfd]="isMfd"
                  class="w-100"
                  classes="textField medium"
                  error="{{ errorDomain }}">
                </xrx-input>
                <button
                  type="button"
                  class="xrx-btn btn-secondary add-btn xgl-plus keep-border"
                  [ngClass]="{ btn: isMfd, medium: isMfd }"
                  (click)="addDomain()"
                  [disabled]="
                    enterDomain.length === 0 || domains.length >= +maxDomains
                  ">
                  <span [xdaTranslate]="'SDE_ADD'"></span>
                </button>
              </div>
            </div>
          }
          <!-- Domain List -->
          @if (domains.length) {
            <div class="address-list-container">
              <ul
                class="list-wrapper list-group"
                [ngClass]="{ 'mb-0': domains.length < 1 }">
                @for (
                  domain of domains;
                  track domain;
                  let i = $index;
                  let first = $first;
                  let last = $last
                ) {
                  <li
                    role="option"
                    class="item list-group-item list-group-item-action d-flex align-items-center justify-content-between"
                    [ngClass]="{ first: first, last: last }">
                    <span class="name">{{ domain }}</span>
                    <div class="icons d-flex align-items-center">
                      @if (!isDomainsRestricted) {
                        <span class="edit" (click)="editDomain(i)"></span>
                      }
                      @if (!(isDomainsRestricted && domains.length == 1)) {
                        <span class="delete" (click)="removeDomain(i)"></span>
                      }
                    </div>
                  </li>
                }
              </ul>
            </div>
          }
          @if (isDomainRequiredError) {
            <div>
              <span
                class="invalid-feedback inline"
                [xdaTranslate]="'SDE_MIN1_DOMAIN_REQUIRED'"></span>
            </div>
          }
          @if (isDomainError) {
            <div>
              <span
                class="invalid-feedback inline"
                [xdaTranslate]="errorDomain"></span>
            </div>
          }
        </div>
      }
    </div>
  }

  <div class="h-divider"></div>

  <!-- User Email Entry -->
  @if (drmConfig.securityMode.display === 'SDE_RESTRICT_TRACK_VIEWERS') {
    <label class="mb-0" [xdaTranslate]="'SDE_USER_LIST'"></label>
  }
  @if (drmConfig.securityMode.display !== 'SDE_RESTRICT_TRACK_VIEWERS') {
    <xrx-toggle-switch
      [label]="'SDE_USER_LIST'"
      [isMfd]="isMfd"
      [switchOn]="drmConfig.enableUserList"
      (toggle)="onToggleSetting('enableUserList')">
    </xrx-toggle-switch>
  }
  @if (
    drmConfig.enableUserList ||
    drmConfig.securityMode.display == 'SDE_RESTRICT_TRACK_VIEWERS'
  ) {
    <div>
      <div
        class="d-flex"
        [ngClass]="
          drmConfig.securityMode.display === 'SDE_RESTRICT_TRACK_VIEWERS'
            ? 'mt-8'
            : 'mt-10'
        ">
        <xrx-input
          type="text"
          id="enterEmail"
          name="enterEmail"
          autocomplete="enterEmail"
          [(ngModel)]="enterEmail"
          placeholder="SDE_ENTER_EMAIL_ADDRESS21"
          [required]="false"
          (change)="onSettingChange($event)"
          [isMfd]="isMfd"
          class="w-100"
          classes="textField medium"
          error="{{ errorEmail }}"
          (keyup)="emailOnKeyup($event)">
        </xrx-input>
        <button
          type="button"
          class="xrx-btn btn-secondary add-btn xgl-plus keep-border"
          [ngClass]="{ btn: isMfd, medium: isMfd }"
          (click)="addUserEmail()"
          [disabled]="
            enterEmail.length === 0 ||
            drmConfig.documentOptions.recipients.length >= +maxUsers
          ">
          <span [xdaTranslate]="'SDE_ADD'"></span>
        </button>
      </div>
      <div class="info mb-10">
        <span
          [xdaTranslate]="'SDE_ENTER_UP_FMTSTR'"
          [formatValues]="[maxUsers]"></span>
        <span>&nbsp;</span>
        @if (
          drmConfig.securityMode.display === 'SDE_TRACK_VIEWERS' &&
          validDomains.length
        ) {
          <span
            [xdaTranslate]="'SDE_FOLLOWING_EMAIL_DOMAINS'"
            [formatValues]="[validDomains.join(', ')]"></span>
        }
        @if (
          drmConfig.securityMode.display !== 'SDE_TRACK_VIEWERS' &&
          allowedDomains.length
        ) {
          <span
            [xdaTranslate]="'SDE_FOLLOWING_EMAIL_DOMAINS'"
            [formatValues]="[allowedDomains.join(', ')]"></span>
        }
      </div>
      <!-- User List -->
      @if (drmConfig.documentOptions.recipients.length) {
        <div class="mb-10">
          <div class="address-list-container">
            <ul
              class="list-wrapper list-group"
              [ngClass]="{
                'mb-0': drmConfig.documentOptions.recipients.length < 1,
              }">
              @for (
                userEmail of drmConfig.documentOptions.recipients;
                track userEmail;
                let i = $index;
                let first = $first;
                let last = $last
              ) {
                <li
                  role="option"
                  class="item list-group-item list-group-item-action d-flex align-items-center justify-content-between"
                  [ngClass]="{ first: first, last: last }">
                  <span class="name">{{ userEmail.email }}</span>
                  <div class="icons d-flex align-items-center">
                    <span class="edit" (click)="editUserEmail(i)"></span>
                    <span class="delete" (click)="removeUserEmail(i)"></span>
                  </div>
                </li>
              }
            </ul>
          </div>
          @if (isEmailRestricted) {
            <div>
              <span
                class="invalid-feedback inline"
                [xdaTranslate]="'SDE_ONE_MORE_EMAIL4'"></span>
            </div>
          }
        </div>
      }
      <div class="mb-10">
        <xrx-toggle-switch
          [label]="'SDE_EMAIL_DOCUMENT_USER'"
          [isMfd]="isMfd"
          [switchOn]="drmConfig.emailDocument"
          (toggle)="onToggleSetting('emailDocument')"
          [disabled]="!drmConfig.documentOptions.recipients.length">
        </xrx-toggle-switch>
      </div>
      @if (drmConfig.emailDocument) {
        <div>
          @if (drmConfig.securityMode.display !== 'SDE_TRACK_VIEWS') {
            <div>
              <div class="cb mb-10">
                <xrx-checkbox
                  label="SDE_DISCLOSE_USER_LIST"
                  [(checkBoxValue)]="drmConfig.documentOptions.distributionList"
                  name="distributionList"
                  (toggle)="onSettingChange($event)"
                  stop-event-propagation></xrx-checkbox>
              </div>
            </div>
          }
          <xrx-input
            type="text"
            id="subject"
            name="subject"
            [(ngModel)]="drmConfig.documentOptions.subject"
            [maxlength]="100"
            placeholder="SDE_ENTER_EMAIL_SUBJECT2"
            [required]="false"
            [autofocus]="errorSubject.length !== 0"
            (change)="onSettingChange($event)"
            [isMfd]="isMfd"
            label="SDE_EMAIL_SUBJECT"
            classes="textField medium"
            error="{{ errorSubject }}"></xrx-input>
          <xrx-textarea
            id="coverLetter"
            name="coverLetter"
            [(ngModel)]="drmConfig.documentOptions.message"
            [rows]="3"
            [maxlength]="1024"
            (change)="onSettingChange($event)"
            [isMfd]="isMfd"
            label="SDE_COVER_LETTER_MESSAGE"
            placeholder="SDE_ENTER_COVER_LETTER"></xrx-textarea>
          @if (drmConfig.securityMode.display !== 'SDE_TRACK_VIEWS') {
            <div class="cb">
              <xrx-checkbox
                label="SDE_EMAIL_PASSCODE_RECIPIENTS"
                [(checkBoxValue)]="drmConfig.documentOptions.verifyCode"
                name="verifyCode"
                (toggle)="onSettingChange($event)"
                stop-event-propagation></xrx-checkbox>
            </div>
          }
        </div>
      }
    </div>
  }
</form>
